import {
  type Project,
  ProjectDetailForClientDocument,
  type ProjectDetailForClientQuery,
  type ProjectDetailForClientQueryVariables,
  SqlOperator,
  TaskSystemStatusEnum,
  TasksForClientDocument,
  type TasksForClientQuery,
  type TasksForClientQueryVariables,
  TaskWhereColumn,
} from "@src/__generated__/graphql";
import { client } from "@src/services/apollo-client";
import type { AppStore } from "@src/stores/AppStore";
import { Filter, Filters } from "@src/utils/components/filters/models";
import { BooleanState } from "@src/utils/mobx/states/BooleanState";
import { action, computed, makeObservable, observable } from "mobx";

type TProject = NonNullable<ProjectDetailForClientQuery>["project"];

export class ProjectDetailForClientsStore {
  appStore: AppStore;
  @observable.ref project?: TProject = undefined;
  @observable.ref tasks: any[] = [];

  @observable isLoading = false;

  where = new Filters<TaskWhereColumn>([
    new Filter({
      column: TaskWhereColumn.ProjectId,
      operator: SqlOperator.Eq,
      options: [],
    }),
  ]);

  constructor(appStore: AppStore) {
    makeObservable(this);
    this.appStore = appStore;
  }

  @observable showDoneTasks = new BooleanState(true);
  showSubtasks = new BooleanState(true);

  @computed get tasksToShow() {
    if (this.showDoneTasks.value) return this.tasks;

    return this.tasks.filter(
      (t) => t.status.system_status !== TaskSystemStatusEnum.Done,
    );
  }

  @action async fetchData(id: Project["id"]) {
    this.isLoading = true;
    const { data } = await client.query<
      ProjectDetailForClientQuery,
      ProjectDetailForClientQueryVariables
    >({
      query: ProjectDetailForClientDocument,
      variables: {
        id,
      },
    });
    this.where.filtersByColumn.get(TaskWhereColumn.ProjectId)?.setValue(id);
    const { data: tasksData } = await client.query<
      TasksForClientQuery,
      TasksForClientQueryVariables
    >({
      query: TasksForClientDocument,
      variables: {
        filters: {
          where: this.where.asWhereParam,
        },
      },
    });

    if (data.project) {
      this.project = data.project;
    }
    if (tasksData.tasks) {
      this.tasks = tasksData.tasks.data;
    }

    this.isLoading = false;
  }

  @action handleAddTaskClick(projectId: string) {
    this.appStore.taskFormModalStore.modalState.onOpen({
      projectId: projectId,
      onSubmit: () => {
        this.fetchData(projectId);
      },
    });
  }
}
